import React from 'react';
import { X } from 'lucide-react';
import { ScheduleTimingForm } from './ScheduleTimingForm';

// Per-filter schedule override modal
export function FilterScheduleModal({
    activeConfigFilter,
    savedFilters,
    getFilterConfig,
    updateFilterConfig,
    addFilterSlot,
    removeFilterSlot,
    updateFilterSlot,
    onClose,
}) {
    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <div className="p-6 border-b border-gray-100 flex items-center justify-between sticky top-0 bg-white z-10">
                    <div>
                        <h2 className="text-xl font-bold text-gray-900">
                            Schedule: {savedFilters.find(f => f.id === activeConfigFilter)?.name}
                        </h2>
                        <p className="text-sm text-gray-500">Override global settings for this specific filter</p>
                    </div>
                    <button type="button" onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full text-gray-500" aria-label="Close">
                        <X className="w-6 h-6" />
                    </button>
                </div>
                <div className="p-6">
                    <ScheduleTimingForm
                        isGlobal={false}
                        frequency={getFilterConfig(activeConfigFilter).frequency}
                        setFrequency={(val) => updateFilterConfig(activeConfigFilter, { frequency: val })}
                        useGlobalQuietHours={getFilterConfig(activeConfigFilter).useGlobalQuietHours}
                        setUseGlobalQuietHours={(val) => updateFilterConfig(activeConfigFilter, { useGlobalQuietHours: val })}
                        quietHoursEnabled={getFilterConfig(activeConfigFilter).quietHoursEnabled}
                        setQuietHoursEnabled={(val) => updateFilterConfig(activeConfigFilter, { quietHoursEnabled: val })}
                        slots={getFilterConfig(activeConfigFilter).slots}
                        addSlot={() => addFilterSlot(activeConfigFilter)}
                        removeSlot={(id) => removeFilterSlot(activeConfigFilter, id)}
                        updateSlot={(id, f, v) => updateFilterSlot(activeConfigFilter, id, f, v)}
                    />
                </div>
                <div className="p-6 border-t border-gray-100 flex justify-end gap-3 sticky bottom-0 bg-white">
                    <button type="button" onClick={onClose} className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg font-medium transition-colors">
                        Close
                    </button>
                    <button type="button" onClick={onClose} className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors shadow-sm">
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
}
